import quickscoreLogo from '../../../assets/img/quickscore-logo.svg'
import type { ImageProps } from '@ztechapps/webui.util'
import { Image } from '@ztechapps/webui.util'

// QuickScore ships a single logo mark (no dark/light variants like
// apps/panelpunches/admin/src/components/logo/logo.tsx) — no useTheme() color-mode switch needed.
export const Logo = (props: Partial<ImageProps>) => <Image {...props} url={quickscoreLogo} name="QuickScore" />
